import React from "react";
import "../../../styles/admin/overall.scss";

const OverallTestAttemptViewer = ({ attemptData }) => {
  if (!Array.isArray(attemptData) || attemptData.length === 0) {
    return (
      <div className="overall-attempt-viewer__empty">
        No attempt data available.
      </div>
    );
  }

  const normalizeLetter = (val) =>
    String(val || "")
      .trim()
      .toUpperCase();

  return (
    <div className="overall-attempt-viewer">
      {attemptData.map((item, idx) => {
        const type = (item.type || "mcq").toLowerCase();
        const options = item.options || {};
        const correctKey = normalizeLetter(item.answer);
        const userKey = normalizeLetter(item.user_answer);
        const isCorrect = correctKey && userKey && correctKey === userKey;

        return (
          <div key={idx} className="overall-attempt-question">
            <div className="overall-attempt-question__header">
              <div className="overall-attempt-question__title">
                <span className="overall-attempt-question__index">
                  Q{item.sequence || idx + 1}.
                </span>
                <span className="overall-attempt-question__text">
                  {item.question}
                </span>
              </div>
              <div className="overall-attempt-question__meta">
                {item.categories && (
                  <span className="overall-attempt-chip overall-attempt-chip--category">
                    {String(item.categories).replace(/_/g, " ")}
                  </span>
                )}
                <span
                  className={`overall-attempt-chip overall-attempt-chip--result ${
                    isCorrect
                      ? "overall-attempt-chip--correct"
                      : "overall-attempt-chip--wrong"
                  }`}
                >
                  {isCorrect ? "Correct" : "Wrong"}
                </span>
              </div>
            </div>

            <div className="overall-attempt-options">
              {Object.entries(options).map(([key, label]) => {
                const k = normalizeLetter(key);
                const isUser = k === userKey;
                const isAns = k === correctKey;
                const optionClasses = ["overall-attempt-option"];
                if (isAns)
                  optionClasses.push("overall-attempt-option--correct");
                if (isUser && !isAns)
                  optionClasses.push("overall-attempt-option--user-wrong");
                if (isUser && isAns)
                  optionClasses.push("overall-attempt-option--user-correct");

                return (
                  <div key={key} className={optionClasses.join(" ")}>
                    <span className="overall-attempt-option__key">{k}.</span>
                    <span className="overall-attempt-option__label">
                      {label}
                    </span>
                    {isUser && (
                      <span className="overall-attempt-option__tag overall-attempt-option__tag--user">
                        User answer
                      </span>
                    )}
                    {isAns && (
                      <span className="overall-attempt-option__tag overall-attempt-option__tag--correct">
                        Correct
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

            {item.hint && (
              <div className="overall-attempt-hint">
                <strong>Hint:</strong> {item.hint}
              </div>
            )}

            {item.explanation && (
              <div className="overall-attempt-explanation">
                <strong>Explanation:</strong> {item.explanation}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OverallTestAttemptViewer;
